module.exports = __webpack_public_path__ + "img/spinner.7c0e03ce.svg";